const initialState = {
  isLoading: false,
  isCompleted: false,
  questions: [],
  activeQuestionIndex: 0,
  notification: null
};

export default initialState;
